import Vue from 'vue';
import bowser from 'bowser';
import { throttle } from './common';

const rate = bowser.mobile ? 1.2 : 0.95;
const windowHeight = window.innerHeight;
const bottomHeight = windowHeight * rate;

// 自动撑高度
function heightFullScreen(wrapper) {
  const tempWrap = wrapper;
  const height = window.innerHeight;
  Vue.nextTick(() => {
    const currentHeight = document.body.getBoundingClientRect().height;
    const wrapperHeight = currentHeight < height ? height - currentHeight : 500;
    tempWrap.style.cssText = `height: ${tempWrap.getBoundingClientRect()
      .height + wrapperHeight}px`;
  });
}
// 判断是否ie
function IEVersion() {
  const { userAgent } = navigator; // 取得浏览器的userAgent字符串
  // 判断是否IE<11浏览器
  const isIE = userAgent.indexOf('compatible') > -1 && userAgent.indexOf('MSIE') > -1;
  const isEdge = userAgent.indexOf('Edge') > -1 && !isIE; // 判断是否IE的Edge浏览器
  const isIE11 = userAgent.indexOf('Trident') > -1 && userAgent.indexOf('rv:11.0') > -1;
  if (isIE) {
    const reIE = new RegExp('MSIE (\\d+\\.\\d+);');
    reIE.test(userAgent);
    const fIEVersion = parseFloat(RegExp.$1);
    if (fIEVersion === 7) {
      return 7;
    } if (fIEVersion === 8) {
      return 8;
    } if (fIEVersion === 9) {
      return 9;
    } if (fIEVersion === 10) {
      return 10;
    }
    return 6;// IE版本<=7
  } if (isEdge) {
    // return 'edge';// edge
    return -1;
  } if (isIE11) {
    return 11; // IE11
  }
  return -1;// 不是ie浏览器
}

function handlerScroll() {
  function doshow(obj, k) {
    const { delay } = obj.dataset;
    const delayTime = delay || 100;
    setTimeout(() => {
      obj.classList.add('animated');
    }, obj.dataset.immediately ? 0 : k * delayTime);
  }
  // 出现显示
  const scolls = [...document.querySelectorAll('.scrollObj')].filter((item) => {
    const isAnimated = item.classList.contains('animated');
    const { top, height } = item.getBoundingClientRect();
    const isInView = top <= bottomHeight && top >= 0;
    if (isAnimated && !isInView && top - height > 0) {
      // item.classList.remove("animated");
    }
    // return !isAnimated && isInView;
    // eslint-disable-next-line max-len
    return (item.dataset.offsetLimit !== undefined && Number(item.dataset.offsetLimit) === 0) ? true : !isAnimated && isInView;
  });
  scolls.forEach((item, key) => {
    if (Number(item.dataset.callback) === 1) {
      item.addEventListener('transitionend', () => {
        if (!item.classList.contains('pause')) {
          item.classList.add('pause');
        }
      });
    }
    doshow(item, key);
  });

  // document.querySelector('.detailGoTop') ||
  const detailGoBack = document.querySelector('.detailGoBack');
  if (detailGoBack) {
    const scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
    if (scrollTop >= window.innerHeight * 0.8) {
      detailGoBack.classList.add('show');
    } else {
      detailGoBack.classList.remove('show');
    }
  }
}

function pageInit() {
  const onScroll = throttle(handlerScroll, 100);
  document.addEventListener('scroll', onScroll);
  onScroll();
}

export default {
  install: () => {
    Vue.prototype.heightFullScreen = (wrapper) => heightFullScreen(wrapper);
    Vue.prototype.IEVersion = () => IEVersion();
    Vue.prototype.pageInit = () => pageInit();
  },
};
